import React, { useState } from 'react';

import {ApiReferenceReact} from '@scalar/api-reference-react'
import '@scalar/api-reference-react/style.css'
import styled from 'styled-components';
import './App.css';
import Header from './Header';
import logo from './header-icon.png';
import {
    ApiSpecId,
    DEFAULT_ENVIRONMENT,
    DEFAULT_SPEC_ID,
    DocsEnvironment,
    getApiSpec,
    isMobbleEmail,
} from './environments';

const AppContainer = styled.div`
    padding-top: 10px; // This should be equal to the height of the Header
`;
// http://localhost:8080/v1/docs/openapi.yaml
const App: React.FC = () => {
    const initialToken = '';
    const [token, setToken] = useState(initialToken);
    const [email, setEmail] = useState('');
    const [environment, setEnvironment] = useState<DocsEnvironment>(DEFAULT_ENVIRONMENT);
    const [specId, setSpecId] = useState<ApiSpecId>(DEFAULT_SPEC_ID);
    const selectedSpec = getApiSpec(environment, specId);

    const handleLoginSuccess = (nextToken: string, nextEmail: string) => {
        setToken(nextToken);
        setEmail(nextEmail);
    };

    return (
        <div className={'App'}>
            <Header
                logoSrc={logo}
                height="60px"
                environment={environment}
                specId={specId}
                canSelectEnvironment={isMobbleEmail(email)}
                onLoginSuccess={handleLoginSuccess}
                onEnvironmentSelect={setEnvironment}
                onAPISpecSelect={setSpecId}
            />

            <AppContainer>
            <ApiReferenceReact
                key={`${environment}:${selectedSpec.id}`}
                configuration={{
                    darkMode: false,
                    spec: {
                        url: selectedSpec.specUrl,
                    },
                    servers: [
                        {
                            url: selectedSpec.serverUrl,
                            description: environment === 'staging' ? 'Staging' : 'Production',
                        },
                    ],
                    authentication: {
                        preferredSecurityScheme: 'BearerAuth',
                        http: {
                            basic:{
                                username:'',
                                password: ''
                            },
                            bearer: {
                                token: token
                            }
                        },
                    }
                }}
            />
            {/*<BaseMap />*/}
            </AppContainer>
        </div>
    );
};

export default App;
